<template>
  <router-view />
</template>

<script setup>
</script>

<style>
/* ═══ Global Reset & Base ═══ */
*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  width: 100%;
  height: 100%;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Hiragino Sans GB',
               'Noto Sans SC', 'WenQuanYi Micro Hei', -apple-system,
               BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  color: #374151;
  background: #f3f4f6;
}
</style>
